import { IPage, ISearchPage } from '@/types/AppTypes';
import { httpRequest } from '@/utils/HttpRequest';
import moment from "moment";

// 统计分析
export interface statisticalType {
	inquiryNum: number;
	offerNum: number;
	saleNum: number;
	purchaseNum: number;
	shipmentNum: number;
}

// 审批中心
export interface approvalList {
	id?: string;
	code?: string;
	auditLevel?: string;
	auditUser?: string; // 审批人
	auditStayUser?: string; //
	status?: number;
	note?: string; // 备注
	createTime?: moment.Moment | null | string;
	auditProject?: string; //
	submitUser?: string;
	deleteFlag?: number;
	updateTime?: string;
	createUser?: string;
}

// 外汇牌价
export interface ICrawlerCurrencyList {
	currencyName?: string; // 外汇币种
	buyingRate?: string; // 现汇买入价
	cashBuyingRate?: string; // 现钞买入价
	sellingRate?: string; // 现汇卖出价
	cashSellingRate?: string; // 现钞卖出价
	middleRate?: string; // 中行折算价
	pubTime?: string; // 发布时间
}

// 提醒中心
export interface IWarningList {
    id?:string; //
    code:string; //
    warningType:string; //
    warningName:string; //
    warningTime:number | string
    shopCode?:string
    shopName?:string
    deleteFlag?:number
    createTime?:string
    updateTime?:string
	warningData?:string
	estimatedTime?:moment.Moment|null|string,
	realCode?:string,
	uncollected?:number | string,
	waitAmount?:number | string,
	purchaseCode?:number | string,
	currencyCode?:string

}

export interface IHomeSearch extends approvalList, ISearchPage {}

class HomeService {
	// 统计分析
	async statistical() {
		const apiUrl = 'gtm/home/statistical';
		return await httpRequest.get<statisticalType>(apiUrl);
	}

	// 审批中心
	async approvalPage(searchVo: IHomeSearch) {
		const apiUrl = '/gtm/audit/search/pg';
		return await httpRequest.post<IPage<approvalList>>(apiUrl, searchVo);
	}

	// 外汇牌价
	async crawlerCurrency() {
		const apiUrl = '/gtm/home/crawlerCurrencyList';
		return await httpRequest.get<ICrawlerCurrencyList[]>(apiUrl);
	}

    // 提醒中心
    async warning(searchVo:Object) {
        const apiUrl = '/gtm/warning/search/pg';
		return await httpRequest.post<IPage<IWarningList>>(apiUrl, searchVo);
    }

	//收款预警
	async payWaring(searchVo:Object){
		const apiUrl = '/gtm/warning/payable';
		return await httpRequest.post<IPage<IWarningList>>(apiUrl, searchVo);
	}
	//付款预警
	async paymentWaring(searchVo:Object , config: object = {}) {
        const apiUrl = "/gtm/warning/payment";
        return await httpRequest.post<IPage<any>>(apiUrl, searchVo, config);
    }
}

export const homeService = new HomeService();
